<template>
  <div>
    <v-dialog :value="true" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Adicionar Recurso</span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="overflow-x: hidden">
          <v-layout row wrap>
            <v-flex xs4 sm4 d-flex>
              <campo-apresentacao v-if="dadosLicitacao.numeroEdital" labelPadrao="Edital" :text="dadosLicitacao.numeroEdital"/>
            </v-flex>
            <v-flex xs8 sm8 d-flex>
              <div class="az-text">
                <label class="label">Objeto</label>
                <div v-if="dadosLicitacao.objeto">
                  <v-tooltip v-if="dadosLicitacao.objeto.length > 148" top nudge-top="15" max-width="600">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <p class="mb-0 text-truncate-multiline texto">{{ dadosLicitacao.objeto.substring(0, 148)+'...' }}</p>
                      </div>
                    </template>
                    <p class="mb-0 text-truncate-multiline" >{{ dadosLicitacao.objeto }}</p>
                  </v-tooltip>
                  <div v-else>
                    <p class="texto">{{ dadosLicitacao.objeto }}</p>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <span class="text-campo" style="margin-bottom: 5px; display: flex;">
                <span>Tipos<span class="ml-1 red--text">*</span></span>
              </span>
              <v-select multiple chips deletable-chips
                  v-model="dadosGerais.lotes"
                  class="select-analise"
                  placeholder="Selecione"
                  :items="lotesDisponiveis"
                  item-text="descricao"
                  item-value="id"
                  item-disabled="prazoEncerradoParaRecurso"
                  :insertNullItem="false"
                  :menu-props="{ top: false, offsetY: true }"
                  name="selectTipos" no-data-text="Nenhum lote disponível">
                <span slot="prepend-item">
                  <v-list-tile ripple @click="selecionarTodosLotes"
                               :disabled="!lotesDisponiveis.some(lote => !lote.prazoEncerradoParaRecurso)">
                    <v-list-tile-action>
                      <v-icon size="20" :color="selecionouAlgumLote ? 'rgb(89, 192, 255)' : ''">{{ icone }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title :color="selecionouAlgumLote ? 'rgb(89, 192, 255)' : ''">
                      Selecionar Todos
                    </v-list-tile-title>
                    <v-tooltip v-if="!lotesDisponiveis.some(lote => !lote.prazoEncerradoParaRecurso)" top
                               max-width="300px" content-class="tooltip-content-centered" class="reativar-hover">
                      <v-chip slot="activator" small class="mx-2" color="orange">Prazo encerrado</v-chip>
                      <span>
                        Todos os tipos estão fora do prazo de recurso, conforme <strong>LEI Nº 14.133, DE 1º DE ABRIL DE 2021</strong>
                      </span>
                    </v-tooltip>
                  </v-list-tile>
                </span>
                <template v-slot:selection="{ item }">
                  <v-tooltip v-if="item.dataFimContrarrazao" top max-width="300px"
                             content-class="tooltip-content-centered">
                    <v-chip slot="activator" close class="v-chip--select-multi"
                            @input="removerLoteSelecionado(item)">
                      {{ item.descricao }}
                    </v-chip>
                    <span>Prazo para contrarrazão até <strong>{{ formatarPrazoContrarrazao(item) }}</strong></span>
                  </v-tooltip>
                  <v-chip v-else close class="v-chip--select-multi"
                          @input="removerLoteSelecionado(item)">
                    {{ item.descricao }}
                  </v-chip>
                </template>
                <template v-slot:item="props">
                  <v-list-tile-action>
                    <v-icon size="20" :color="props.tile.props.value ? 'rgb(89, 192, 255)' : ''">
                      {{ props.tile.props.value ? 'check_box' : 'check_box_outline_blank' }}
                    </v-icon>
                  </v-list-tile-action>
                  {{props.item.descricao}}
                  <v-tooltip v-if="props.item.dataFimContrarrazao" top class="reativar-hover"
                             max-width="300px" content-class="tooltip-content-centered">
                    <v-icon slot="activator" size="16" class="mx-1" color="grey darken-1">schedule</v-icon>
                    <span>Prazo para contrarrazão até <strong>{{ formatarPrazoContrarrazao(props.item) }}</strong></span>
                  </v-tooltip>
                  <v-tooltip top class="reativar-hover" content-class="tooltip-content-centered">
                    <v-chip slot="activator" v-if="props.item.prazoEncerradoParaRecurso" small class="mx-2" color="orange">Prazo encerrado</v-chip>
                      Este tipo não está disponível pois o prazo para envio de recursos <br>está encerrado, conforme <strong>LEI Nº 14.133, DE 1º DE ABRIL DE 2021</strong>
                  </v-tooltip>
                </template>
                <v-divider slot="prepend-item" class="mt-2"/>
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row v-if="possuiPrazosContrarrazaoDivergentes">
            <v-flex xs12>
              <div class="card-alerta-prazo">
                <v-icon size="20" color="#B25E02" class="card-alerta-prazo-icone">warning</v-icon>
                <div class="card-alerta-prazo-texto">
                  <strong>Os tipos selecionados possuem prazos de contrarrazão diferentes.</strong>
                  <span>
                    Prazos encontrados: {{ prazosContrarrazaoFormatados }}.
                    Um recurso só pode agrupar tipos com o mesmo prazo de contrarrazão.
                    Selecione apenas tipos de um mesmo prazo ou abra um recurso para cada grupo.
                  </span>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <p class="text-campo" style="margin-top: 4px">Conteúdo Recurso
          <span class="ml-1 red--text">*</span>
          <span class="ml-1 red--text" v-if="limiteTextoAtingido">Limite máximo de caracteres atingido!</span></p>
          <v-textarea rows="2" auto-grow class="textarea-conteudo-recurso required-field" placeholder="Informe o conteúdo..."
                      v-model="dadosGerais.conteudo" v-on:keyup="contarTamanhoTexto" counter/>
          <div>
            <p class="text-campo" style="margin-bottom: 4px">Anexos</p>
            <licitacao-recurso-contrarrazao-anexo style="margin-top: -25px" :dadosRecursoContrarrazao="dadosGerais"/>
          </div>
        </v-card-text>
        <div class="az-actions-form actions-modal">
          <button class="action-secundary-button" @click="fecharModal">Cancelar</button>
          <button v-if="podeSalvarRecurso" class="action-primary-button"
                  @click.prevent="confirmarResposta">
            Enviar Recurso
          </button>
          <div v-else>
            <v-tooltip top nudge-top="10" max-width="280" content-class="tooltip-content-centered">
              <template v-slot:activator="{ on }">
                <button v-on="on" class="action-primary-button-disabled btn-disabled">Enviar Recurso</button>
              </template>
              {{ mensagemBloqueioEnvio }}
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <modal-confirmar-etapa-anexo
        v-model="modalConfirmarEnvio"
        :title="'Confirmar Envio'"
        :max-width="'450'"
        :text="mensagemConfirmacao"
        second-text="Esta ação NÃO PODERÁ ser desfeita!"
        @fecharModalConfirm="naoContinuarSemAnexo"
        @cancelarAcao="naoContinuarSemAnexo"
        @confirmarAcao="enviarRecurso"
    />
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import {actionTypes} from '@/commons/constants'
import CampoApresentacao from '@/commons/components/campos/campo-apresentacao.vue'
import ModalConfirmarEtapaAnexo from '@/commons/components/ModalConfirmarEtapaAnexo.vue'
import BotaoAnexo from '@/commons/components/botoes/BotaoAnexo.vue'
import LicitacaoEsclarecimentoAnexo from '../../../commons/CredenciamentoEsclarecimentoAnexo.vue'
import LicitacaoRecursoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo.vue";
import LicitacaoRecursoContrarrazaoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo.vue";
import moment from 'moment/moment'

const FORMATO_PRAZO_CONTRARRAZAO = 'DD/MM/YYYY HH:mm'

export default {
  name: 'ModalInserirRecurso',
  components: {
    LicitacaoRecursoContrarrazaoAnexo, LicitacaoRecursoAnexo, BotaoAnexo,
    LicitacaoEsclarecimentoAnexo, ModalConfirmarEtapaAnexo, CampoApresentacao
  },
  props: {
    dadosLicitacao: {
      type: Object,
      default: null
    },
    maxWidth: {
      type: String,
      default: '800'
    },
    lotesDisponiveis:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      limiteTextoAtingido: false,
      maxTextArea: 1000,
      totalRemainCount: 1000,
      modalConfirmarEnvio: false,
      dadosGerais: {
        lotes: [],
        conteudo: null,
        anexos: null,
      },
      repository: 'repo1:licitacao',
    }
  },
  computed:{
    lotesSelecionados() {
      return this.lotesDisponiveis.filter(lote => this.dadosGerais.lotes.includes(lote.id))
    },
    prazosContrarrazaoSelecionados() {
      const prazos = this.lotesSelecionados.map(lote => lote.dataFimContrarrazao || null)
      return [...new Set(prazos)]
    },
    possuiPrazosContrarrazaoDivergentes() {
      return this.prazosContrarrazaoSelecionados.length > 1
    },
    prazosContrarrazaoFormatados() {
      return this.prazosContrarrazaoSelecionados
        .slice()
        .sort()
        .map(prazo => prazo ? this.formatarPrazoContrarrazao({dataFimContrarrazao: prazo}) : 'prazo não definido')
        .join(', ')
    },
    camposObrigatoriosPreenchidos() {
      return this.dadosGerais.lotes.length > 0
        && !!this.dadosGerais.conteudo
        && !!this.dadosGerais.conteudo.trim()
    },
    podeSalvarRecurso() {
      return this.camposObrigatoriosPreenchidos && !this.possuiPrazosContrarrazaoDivergentes
    },
    mensagemBloqueioEnvio() {
      return this.possuiPrazosContrarrazaoDivergentes
        ? 'Selecione apenas tipos com o mesmo prazo de contrarrazão para continuar.'
        : 'É necessário que todos os campos obrigatórios sejam preenchidos para continuar.'
    },
    nenhumAnexoInserido(){
      return !this.dadosGerais.anexos || !this.dadosGerais.anexos.length > 0
    },
    mensagemConfirmacao(){
      if(this.nenhumAnexoInserido) {
        return 'Atenção, nenhum anexo foi inserido, deseja continuar?'
      }else{
        return 'Atenção! Você está inserindo um recurso. Deseja continuar?'
      }
    },
    selecionouTodosLotes() {
      const quantidadeLotesDisponiveisNoPrazo = this.lotesDisponiveis.filter(lote=>!lote.prazoEncerradoParaRecurso).length
      const quantidadeLotesSelecionados = this.dadosGerais.lotes.length
      return quantidadeLotesSelecionados > 0 && quantidadeLotesSelecionados === quantidadeLotesDisponiveisNoPrazo
    },
    selecionouAlgumLote() {
      return this.dadosGerais.lotes.length > 0
    },
    icone() {
      if (this.selecionouTodosLotes) return 'check_box'
      if (this.selecionouAlgumLote && !this.selecionouTodosLotes) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    }
  },
  methods: {
    ...mapActions([actionTypes.INSERIR_RECURSO]),
    formatarPrazoContrarrazao(lote) {
      const prazo = moment(lote.dataFimContrarrazao)
      return prazo.isValid() ? prazo.format(FORMATO_PRAZO_CONTRARRAZAO) : '-'
    },
    removerLoteSelecionado(lote) {
      this.dadosGerais.lotes = this.dadosGerais.lotes.filter(id => id !== lote.id)
    },
    fecharModal() {
      this.dadosGerais = {
        lotes: [],
        conteudo: null,
        anexos: null
      }
      if(this.modalConfirmarEnvio){
        this.modalConfirmarEnvio = false
      }
      this.$emit('fecharModal')
    },
    naoContinuarSemAnexo(){
      this.modalConfirmarEnvio = false
    },
    confirmarResposta() {
      this.modalConfirmarEnvio = true
    },
    enviarRecurso(){
      this.$emit('enviarRecurso', this.dadosGerais)
    },
    contarTamanhoTexto(){
      this.totalRemainCount = this.maxTextArea - this.dadosGerais.conteudo.length;

      this.limiteTextoAtingido = this.totalRemainCount < 0;
      if(this.limiteTextoAtingido) this.dadosGerais.conteudo = this.dadosGerais.conteudo.slice(0, this.totalRemainCount)
    },
    selecionarTodosLotes() {
      this.$nextTick(() => {
        if (this.selecionouTodosLotes) {
          this.dadosGerais.lotes = []
        } else {
          this.dadosGerais.lotes = this.lotesDisponiveis.filter(lote=>!lote.prazoEncerradoParaRecurso).map(lote => lote.id)
        }
      })
    }
  }
}
</script>

<style lang="stylus">

.max-percent
  max-width 90%

.tabulacao-content
  margin-left 10px

.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

.actions-modal
  border-top solid thin rgba(0, 0, 0, .12)
  padding-top 10px
  margin-top 0

&-conteudo
  min-height 350px

.container-header-text
  display flex
  flex-direction row
  justify-content center
  align-items center

.text-campo
  margin 0
  font-size 14px
  font-weight bold
  color #3A6861 !important

.card-alerta-prazo
  display flex
  align-items flex-start
  width 100%
  margin 8px 0 4px
  padding 12px 14px
  border 1px solid #F0C68A
  border-left 4px solid #E08600
  border-radius 4px
  background-color #FFF6E8

.card-alerta-prazo-icone
  flex 0 0 auto
  margin-right 10px
  line-height 1.4

.card-alerta-prazo-texto
  flex 1 1 auto
  min-width 0
  font-size 13px
  line-height 1.4
  color #6B4A12
  overflow-wrap anywhere

  strong
    display block
    margin-bottom 2px
    color #8A5B00

.textarea-conteudo-recurso
  padding-top 0 !important

  textarea
    padding 5px !important
    color #777 !important

  .v-input__slot
    border 1px solid #CCCCCC
    border-radius 5px

.select-analise
  margin 0 !important
  padding-top 0 !important
  .v-select__selections
    color #777 !important

.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.texto
  font-size 14px
  color #777 !important

.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active
    max-height 232px!important;

.rotacao-180
  -webkit-transform rotate(180deg)
  -moz-transform rotate(180deg)
  -o-transform rotate(180deg)
  -ms-transform rotate(180deg)
  transform: rotate(180deg)

.v-list__tile__action
  min-width 0 !important

.reativar-hover
  pointer-events all !important
  cursor auto !important

.v-list__tile__title
  width unset !important

.tooltip-content-centered
  text-align center
</style>